import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as dayjs from 'dayjs';
import * as minMax from 'dayjs/plugin/minMax';
import { GlobalConstants } from 'src/app/constant/constant';
import { TimeRecord } from 'src/app/entities/timeRecord';
import { TimeRecordService } from 'src/app/services/timeRecord.service';
import { TimeFormDataValues, TimeFormControlParams } from '../time.component';
import { DateTimeHelper } from 'src/app/utils/date-time-helper';
dayjs.extend(minMax);

@Component({
  selector: 'app-edit-closed-time',
  templateUrl: './edit-closed-time.component.html',
  styleUrls: ['./edit-closed-time.component.scss'],
})
export class EditClosedTimeComponent implements OnInit {
  @Input() interval: number = GlobalConstants.DEFAULT_TIMECLOCK_INTERVAL_MINUTES;
  get INTERVAL() { return this.interval; }

  @Input() userId: number;
  @Input() timeRecordToEdit: TimeRecord;
  @Output() formValuesChanged = new EventEmitter<TimeFormDataValues>();
  timeFormControlParams: TimeFormControlParams;

  constructor(
    private timeRecordService: TimeRecordService
  ) {}

  ngOnInit() {
    this.setFormParams();
  }

  onFormValuesChanged(formValues: TimeFormDataValues) {
    this.formValuesChanged.emit(formValues);
  }

  setFormParams() {
    const now = DateTimeHelper.getLocalNow();
    const nowRounded = DateTimeHelper.roundDateTime(dayjs(now), this.INTERVAL).tz(this.timeRecordToEdit.ClockInTimeZoneId);
    const timeRecordDate = this.timeRecordToEdit.Date;
    const lastAllowedClockIn = this.timeRecordService.getLastAllowedClockInForDay(timeRecordDate, this.INTERVAL).tz(this.timeRecordToEdit.ClockInTimeZoneId);
    const firstAllowedClockOut = this.timeRecordService.getFirstAllowedClockOutForDay(timeRecordDate, this.INTERVAL, this.timeRecordToEdit.ClockIn);
    const startOfDay = DateTimeHelper.getStartOfDay(timeRecordDate);

    const prelimEndTimeMaxValue = dayjs.min([nowRounded, DateTimeHelper.getEndOfDay(timeRecordDate)]).tz(this.timeRecordToEdit.ClockInTimeZoneId);
    const lastIntervalBeforeMidnight = DateTimeHelper.subtractTime(DateTimeHelper.getStartOfNextDay(timeRecordDate), this.INTERVAL, 'minute').tz(this.timeRecordToEdit.ClockInTimeZoneId);
    const endOfDay = DateTimeHelper.getEndOfDay(timeRecordDate);
    const isMidnightTheMaxValue = DateTimeHelper.checkIsSame(endOfDay, 'UTC', prelimEndTimeMaxValue, 'UTC', 'minute');

    this.timeFormControlParams = {
      ...this.timeFormControlParams,
      timeRecordToEditRecordId: this.timeRecordToEdit.RecordId,
      date: {
        initialValue: DateTimeHelper.formatDateTime(timeRecordDate),
        isDisabled: true,
      },
      startTime: {
        initialValue: DateTimeHelper.formatDateTime(this.timeRecordToEdit.ClockIn),
        minValue: startOfDay.format('HH:mm'),
        maxValue: dayjs.min([nowRounded, lastAllowedClockIn]).format('HH:mm'),
      },
      endTime: {
        initialValue: DateTimeHelper.formatDateTime(this.timeRecordToEdit.ClockOut),
        minValue: firstAllowedClockOut.format('HH:mm'),
        maxValue:  dayjs.min([nowRounded, lastIntervalBeforeMidnight]).format('HH:mm'),
        allowMidnight: isMidnightTheMaxValue,
      }
    };
  }
}
